(function(angular, _) {
    /**
     * @ngdoc service
     * @name PathVertexFactory
     * @description Represents the path graph vertex
     */
    class PathVertexFactory {
        constructor(value = null, meta = {}) {
            this.uuid = _.uniqueId('vertex');
            this.value = value;
            this.meta = meta;
            this.level = null;

            this.inboundEdges = [];
            this.outboundEdges = [];
        }

        get hasInboundEdges() {
            return _.some(this.inboundEdges);
        }

        get hasOutboundEdges() {
            return _.some(this.outboundEdges);
        }

        getInboundEdges() {
            return this.inboundEdges;
        }

        addInboundEdge(edge) {
            this.inboundEdges.push(edge);

            return this;
        }

        removeInboundEdge(edge) {
            const index = _.findIndex(this.inboundEdges, (inbound) => inbound === edge);

            if (index > -1) {
                this.inboundEdges.splice(index, 1);
            }

            return this;
        }

        getOutboundEdges() {
            return this.outboundEdges;
        }

        addOutboundEdge(edge) {
            this.outboundEdges.push(edge);

            return this;
        }

        removeOutboundEdge(edge) {
            const index = _.findIndex(this.outboundEdges, (outbound) => outbound === edge);

            if (index > -1) {
                this.outboundEdges.splice(index, 1);
            }

            return this;
        }

        getLevel() {
            return this.level;
        }

        setLevel(level) {
            this.level = level;

            return this;
        }

        getValue() {
            return this.value;
        }

        setValue(value) {
            this.value = value;

            return this;
        }

        getMeta(path = null) {
            if (path) {
                return _.get(this.meta, path, null);
            }

            return this.meta;
        }

        setMeta(meta, value) {
            if (_.isPlainObject(meta)) {
                this.meta = meta;
            } else if (_.isUndefined(value)) {
                delete this.meta[meta];
            } else if (_.isString(meta)) {
                _.set(this.meta, meta, value);
            }

            return this;
        }

        toJSON() {
            return _.chain(this)
                .pick(['uuid', 'value', 'meta'])
                .cloneDeep()
                .value();
        }

        destroy() {
            this.uuid = null;
            this.value = null;
            this.meta = null;
            this.level = null;
        }
    }

    angular.module('wtApp.dataService')
        .factory('PathVertexFactory', () => PathVertexFactory);
})(window.angular, window._);
